<template>
    <form
        @submit="onFormSubmit($event)"
    >
        <div v-for="(form, index) in forms" :key="index">
            <div v-if="form.name === activeForm">
                    <DxForm
                        ref="form"
                        :col-count="form.colCount"
                        :form-data="getData(form.name)"
                        :show-colon-after-label="true"
                    >
                        <DxGroupItem
                            v-for="(group, index) in form.fieldgroups"
                            :key="index"
                            :caption="group.title"
                            :col-span="group.colSpan"
                        >
                        <DxSimpleItem 
                            v-for="(item, index) in group.fields" 
                            :key="index"
                        >
                           <template #default>
                                <DxLabel :text="item.label"/> 
                                <div>
                                    <DxTextBox
                                        v-if="item.controlType==='dxTextBox'"
                                        v-model:value="itemSelect[item.name]"
                                        @value-changed="changeField($event, item)"
                                        :read-only="item.readOnly"
                                        :disabled="item.readOnly"
                                    >
                                        <DxTextBoxButton
                                            v-if="item.info"
                                            :options="infoBtn(item)"
                                            :name="item.name"
                                            location="after"
                                        />
                                        <DxValidator>
                                            <DxRequiredRule 
                                                v-if="item.mandatory"
                                                :message="item.requiredMessage ? item.requiredMessage:'Este campo es obligatorio.'"
                                            />
                                            <DxEmailRule 
                                                v-if="item.validationType==='email'"
                                                :message="item.validationMessage"
                                            />
                                            <DxNumericRule
                                                v-if="item.validationType==='numeric'"
                                                :message="item.validationMessage"
                                            />
                                            <DxPatternRule
                                                v-if="item.validationType==='pattern'"
                                                :message="item.validationMessage"
                                                :pattern="RegExp(item.pattern)"
                                            />
                                        </DxValidator>
                                    </DxTextBox>
                                    <DxSelectBox
                                        v-if="item.controlType==='dxSelectBox'"
                                        v-model:value="itemSelect[item.name]"
                                        @value-changed="changeField($event, item)"
                                        :data-source="lists[item.name]"
                                        displayExpr="display"
                                        valueExpr="value"
                                        :read-only="item.readOnly"
                                        :disabled="isDisabled(lists[item.name])"
                                        :placeholder="isDisabled(lists[item.name]) ? item.placeholder : 'Seleccionar...'"
                                    />
                                    <DxDateBox
                                        v-if="item.controlType==='dxDateBox'"
                                        v-model:value="itemSelect[item.name]"
                                        @value-changed="changeField($event, item)"
                                        :read-only="item.readOnly"
                                        :disabled="item.readOnly"
                                    >
                                        <DxValidator>
                                            <DxRangeRule
                                                v-if="item.validationType==='date'"
                                                :max="new Date().setFullYear(new Date().getFullYear() - item.max)"
                                                :message="item.validationMessage"
                                            />
                                        </DxValidator>
                                    </DxDateBox>
                                    <DxTextArea 
                                        v-if="item.controlType==='dxTextArea'"
                                        v-model:value="itemSelect[item.name]"
                                        @value-changed="changeField($event, item)"
                                        :height="112"
                                        :disabled="item.readOnly"
                                    />
                                    <div
                                        style="padding-top: 7px"
                                        v-if="item.controlType==='dxRadioGroup'"
                                    >
                                    <DxRadioGroup
                                        :data-source="item.items"
                                        :value="item.items[0]"
                                        displayExpr="display"
                                        :layout="item.layout"
                                        @value-changed="changeField($event, item)"
                                    />
                                    </div>
                                    <DxTagBox
                                        v-if="item.controlType==='dxTagBox'"
                                        :data-source="item.items"
                                        v-model:value="itemSelect[item.name]"
                                        displayExpr="display"
                                        valueExpr="value"
                                        :show-selection-controls="true"
                                        apply-value-mode="useButtons"
                                    />
                                    <DxHtmlEditor
                                        v-if="item.controlType==='dxHtmlEditor'"
                                        v-model:value="itemSelect[item.name]"
                                        :height="300"
                                    >
                                        <DxToolbar 
                                            v-if="item.toolbar"
                                            :multiline="true">
                                            <DxItem format-name="undo"/>
                                            <DxItem format-name="redo"/>
                                            <DxItem format-name="separator"/>
                                            <DxItem
                                                :format-values="sizeValues"
                                                format-name="size"
                                            />
                                            <DxItem
                                                :format-values="fontValues"
                                                format-name="font"
                                            />
                                            <DxItem format-name="separator"/>
                                            <DxItem format-name="bold"/>
                                            <DxItem format-name="italic"/>
                                            <DxItem format-name="strike"/>
                                            <DxItem format-name="underline"/>
                                            <DxItem format-name="separator"/>
                                            <DxItem format-name="alignLeft"/>
                                            <DxItem format-name="alignCenter"/>
                                            <DxItem format-name="alignRight"/>
                                            <DxItem format-name="alignJustify"/>
                                            <DxItem format-name="separator"/>
                                            <DxItem format-name="orderedList"/>
                                            <DxItem format-name="bulletList"/>
                                            <DxItem format-name="separator"/>
                                            <DxItem
                                                :format-values="headerValues"
                                                format-name="header"
                                            />
                                            <DxItem format-name="separator"/>
                                            <DxItem format-name="color"/>
                                            <DxItem format-name="background"/>
                                            <DxItem format-name="separator"/>
                                            <DxItem format-name="link"/>
                                            <DxItem format-name="image"/>
                                            <DxItem format-name="separator"/>
                                            <DxItem format-name="clear"/>
                                            <DxItem format-name="codeBlock"/>
                                            <DxItem format-name="blockquote"/>
                                            <DxItem format-name="separator"/>
                                            <DxItem format-name="insertTable"/>
                                            <DxItem format-name="deleteTable"/>
                                            <DxItem format-name="insertRowAbove"/>
                                            <DxItem format-name="insertRowBelow"/>
                                            <DxItem format-name="deleteRow"/>
                                            <DxItem format-name="insertColumnLeft"/>
                                            <DxItem format-name="insertColumnRight"/>
                                            <DxItem format-name="deleteColumn"/>
                                        </DxToolbar>
                                    </DxHtmlEditor>
                                </div>
                            </template>
                        </DxSimpleItem>
                        </DxGroupItem>
                    </DxForm>
                <div class="form-buttons">
                    <DxButton
                        icon="floppy"
                        text="guardar"
                        type="default"
                        styling-mode="text"
                        :use-submit-behavior="true"
                    />
                    <DxButton
                        icon="clear"
                        text="cancelar"
                        type="default"
                        styling-mode="text"
                        @click="cancelForm"
                    />
                </div>
            </div>
        </div>
    </form>
        <DxPopover
            v-for="(item, index) in formItems"
            :key="index"
            :visible="defaultVisible[item.name]"
            :target="`#${item.name}`"
            :close-on-outside-click="false"
            :width="250"
        >
            <p class="popover-content">{{item.infoMessage}}</p>
        </DxPopover>
</template>

<script>
    /**
     * Importaciones devExtreme
     */
    import { DxForm, 
            DxSimpleItem, 
            DxGroupItem,
            DxLabel } from 'devextreme-vue/form';
    import { DxValidator,
            DxRequiredRule,
            DxEmailRule,
            DxNumericRule,
            DxPatternRule,
            DxRangeRule } from 'devextreme-vue/validator';
    // import DxTextBox from 'devextreme-vue/text-box';
    import DxSelectBox from 'devextreme-vue/select-box';
    import DxDateBox from 'devextreme-vue/date-box';
    import DxButton from 'devextreme-vue/button';
    import { DxTextArea } from 'devextreme-vue/text-area';
    import DxRadioGroup from 'devextreme-vue/radio-group';
    import DxTagBox from 'devextreme-vue/tag-box';
    import {DxHtmlEditor,
            DxToolbar,
            DxItem } from 'devextreme-vue/html-editor';
    
    //PRUEBAS
    import { DxTextBox, DxButton as DxTextBoxButton } from 'devextreme-vue/text-box';
    import { DxTooltip } from 'devextreme-vue/tooltip';
    import { DxPopover } from 'devextreme-vue/popover';


    /**
     * Importaciones Vue
     */
    import { computed, ref } from 'vue';
    import { useStore } from 'vuex';

    export default {
        name:'Form',
        components:{
            DxForm,
            DxGroupItem,
            DxSimpleItem,
            DxButton,
            DxTextArea,
            DxLabel,
            DxRequiredRule,
            DxEmailRule,
            DxValidator,
            DxTextBox,
            DxSelectBox,
            DxDateBox,
            DxNumericRule,
            DxPatternRule,
            DxRangeRule,
            DxRadioGroup,
            DxTagBox,
            DxHtmlEditor,
            DxToolbar,
            DxItem,
            //PRUEBAS
            DxTextBoxButton,
            DxTooltip,
            DxPopover
        },
        props:{
            itemSelect:{
                type: Object,
                default: {}
            }
        },
        setup(props) {   
            const store = useStore();
            const form = ref(null);
            const lists = ref({})

            /**
             * COMPUTED PROPERTIES
             */
            const forms = computed( () => store.state.tableItems.configuration.forms );
            const activeForm = computed( () => store.state.activeForm );

            /**
             * METHODS
             */

            const onFormSubmit = (e) => { 
                console.log(props.itemSelect)
                store.dispatch('activePopup');
                store.dispatch('changeForm','');
                lists.value = {}
                e.preventDefault(); 
            }

            const cancelForm = () => {
                store.dispatch('activePopup');
                store.dispatch('changeForm','');
                lists.value = {}
            }

            const selectBox = (selected, field) => {
                let radioChilds = [];
                /**
                 * Genera el contenido de los componentes selectBox hijos
                 * dependiendo del padre seleccionado
                 * Recibe:
                 *    - selected: la opción  seleccionada.
                 *    - field: el campo que contiene esa opción.
                 */
                if(selected){
                    store.state.tableItems.configuration.forms.forEach( form => {
                        form.fieldgroups.forEach( item => {
                            item.fields.forEach( el => {
                                field.childNameList.forEach( child => {
                                    if(el.name === child){
                                        lists.value[child] = el.items.filter( e => e.parentValue === selected.value)
                                    }
                                } )
                            })
                        })
                    })  
                return
                }
                store.state.tableItems.configuration.forms.forEach( form => {
                    form.fieldgroups.forEach( group => {
                        group.fields.forEach( item => {
                            /**
                             * Genera el contenido de los componentes selectBox padres 
                             */
                            if(item.controlType === 'dxSelectBox'){
                                if(!lists.hasOwnProperty( item )){
                                    item.items.forEach( el => {
                                        if(!el.hasOwnProperty('parentValue')){
                                            lists.value[item.name] = item.items
                                        }
                                    })
                                }
                            }
                            /**
                             * Genera el contenido de los componentes selectBox hijos 
                             * de componentes dxRadioGroup
                             */
                            if(item.controlType === 'dxRadioGroup'){
                                item.childNameList.forEach(el => radioChilds.push({item: item.items[0],childs: [el]}))
                            }
                            radioChilds.forEach( child => {
                                child.childs.forEach(el => {
                                    if(item.name === el){
                                        lists.value[item.name] = item.items.filter( e => e.parentValue === child.item.value )
                                    }
                                })
                            })
                        })
                    })
                })
            }

            const changeField = (e, field) => {
                /**
                 * Se ejecuta cuando se detecta el evento change. Si el componente que ejecuto el evento 
                 * tiene hijos, los completa filtrando su contenido.
                 */
                let selected = {};

                if(field.controlType === 'dxSelectBox' || field.controlType === 'dxRadioGroup'){
                    field.items.forEach(el => {
                            if(el.value === e.value || el === e.value){
                            selected = el;
                        }
                    });
                    if(field.hasOwnProperty('childNameList')) {
                    selectBox(selected, field);
                    return
                    }
                }

                props.itemSelect[field.name] = e.value;
            }

            const getData = (form) => {
                if(form === 'edit'){
                    return props.itemSelect
                }
                return {}
            }

            const isDisabled = (item) => {
                if(item){
                    if(Object.keys(item).length === 0){ 
                        return true;
                        }
                    return false;
                }
                return true;
            } 

            /**
             * Contenido de los controles de la Toolbar
             * -Puede venir en el JSON?
             */
            const sizeValues = ['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt'];
            const fontValues = ['Arial', 'Courier New', 'Georgia', 'Impact', 'Lucida Console', 'Tahoma', 'Times New Roman', 'Verdana'];
            const headerValues = [false, 1, 2, 3, 4, 5];

            //PRUEBAS
            const defaultVisible = ref({})
            const infoBtn = (item) => {

                return {
                    icon: 'info',
                    type: 'text',
                    focusStateEnabled: false,
                    elementAttr: {id: item.name },
                    onClick: () => {
                        defaultVisible.value[item.name] = !defaultVisible.value[item.name]
                    }
                }

            }

            const formItems = computed( () => {
                const infoItems = [];
                store.state.tableItems.configuration.forms.forEach( form => {
                    if(form.name === activeForm.value){
                        form.fieldgroups.forEach( fieldgroup => {
                            fieldgroup.fields.forEach( El => {
                                if(El.info){
                                    // console.log(El);
                                    defaultVisible.value[El.name] = false;
                                    infoItems.push(El);
                                }
                            });
                        });
                    };
                });
                return infoItems;
            });

            return {
                forms,
                activeForm,
                cancelForm,
                form,
                selectBox,
                lists,
                onFormSubmit,
                changeField,
                getData,
                isDisabled,
                sizeValues,
                fontValues,
                headerValues,
                //PRUEBAS
                infoBtn,
                defaultVisible,
                formItems,
            }
        }
    }
</script>

<style>
    #form {
        padding: 20px 20px 0 20px;
    }
    .form-buttons {
        display: flex;
        justify-content: flex-end;
        margin-top: 10px;
    }

    .form-buttons .dx-button:first-child {
        margin-right: 10px;
    }

    .popover-content {
        font-size: 11px;
    }
    .info-msg {
        padding: 0px;
    }

</style>